// blog — or. BlogNews page copy.

export default {
  blogEyebrow: 'Qabiyyee fi Roowwata',
  blogTitleA: 'Bloggii',
  blogTitleB: 'faa',
  blogHeroDesc: 'Karoora daldalaa, idaa dijitaalaa, e-commerce, waaree daldalaa All Things ilaallatu barbaadaa booda adeemtuuf carraa qabsiifamee sochoa daldaltoota Itoophiyaa eegaa.',
  blogTabBlog: 'Bloggii',
  blogTabNews: 'Waaree',
  blogSearchPlaceholder: 'Barreeffama barbaadi...',
  blogSortNewest: 'Haaraa',
  blogSortOldest: 'Duubatti',
  blogEmptyTitle: 'Barreeffama hin argamne',
  blogEmptyDesc: 'Barbaadinni yookaan gosa biraa fayyadamii.',
  blogFeaturedTitle: 'Barreeffama Filattee',
  blogMoreTitle: 'Barreeffama Dabalata',
  blogCategoriesTitle: 'Gosota',
  blogReadMore: 'Dabalata Dubbifadhu',
  blogSourceRef: 'Madda Obboolee ↗',
};